module.exports = __webpack_public_path__ + "img/mobile-screen-active.add0f5fc.svg";